import { message } from "antd";
import { call, put, takeLatest } from "redux-saga/effects";
import { getProfileDetails } from "../auth/slice";
import {
  addCommentFialure,
  addCommentRequest,
  addCommentSuccess,
  createPostFailure,
  createPostRequest,
  createPostSuccess,
  deleteCommentFialure,
  deleteCommentRequest,
  deleteCommentSuccess,
  deletePostFailure,
  deletePostRequest,
  editCommentFialure,
  editCommentRequest,
  editCommentSuccess,
  fetchPostByIdFailure,
  fetchPostByIdRequest,
  fetchPostByIdRequestForcontent,
  fetchPostByIdSuccess,
  fetchPostByIdSuccessForcontent,
  fetchPostsFailure,
  fetchPostsRequest,
  fetchPostsRequestForDashboard,
  fetchPostsSuccessForDashBoard,
  fetchPostsSuccessForTable,
  togglePublishByIdFailure,
  togglePublishByIdRequest,
  togglePublishByIdSuccess,
  togglePublishFailure,
  togglePublishRequest,
  togglePublishSuccess,
  toggleUnpublishByIdFailure,
  toggleUnpublishByIdSuccess,
  toggleUnpublishFailure,
  toggleUnpublishSuccess,
  UpdatePostFailure,
  UpdatePostRequest,
  UpdatePostSuccess,
} from "./slice";
import {
  addComment,
  createPost,
  deleteComment,
  deletePost,
  editComment,
  getPostById,
  getPosts,
  togglePostPublish,
  togglePostUnpublish,
  updatePostById,
} from "./utils";

function* handlecreatePost(action) {
  try {
    const token = localStorage.getItem("token");
    const response = yield call(createPost, token, action.payload);
    yield put(createPostSuccess(response.data));
    yield put(fetchPostsRequest({ page: 1, size: 7 }));
    message.success("Post created successfully!");
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Failed to create posts";
    
    yield put(createPostFailure(errorMsg));
  }
}

function* handleFetchPosts(action) {
  try {
    const response = yield call(getPosts, action.payload);
    yield put(
      fetchPostsSuccessForTable({
        posts: response.data.data,
        meta: response.data.meta,
      }),
    );
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Failed to fetch posts";
    yield put(fetchPostsFailure());
    message.error(errorMsg);
  }
}

function* handleFetchPostsForDashBoard(action) {
  try {
    const response = yield call(getPosts, action.payload);
    yield put(
      fetchPostsSuccessForDashBoard({
        posts: response.data.data,
        meta: response.data.meta,
      }),    
    );
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Failed to fetch posts";
    yield put(fetchPostsFailure());
    message.error(errorMsg);
  }
}

function* handleDeletePost(action) {
  const { postId, meta } = action.payload;
  try {
    yield call(deletePost, postId);
    yield put(fetchPostsRequest(meta));
    message.success("Post deleted successfully!");
  } catch (error) {
    yield put(deletePostFailure());
    const errorMsg = error?.response?.data?.message || "Failed to delete post";
    message.error(errorMsg);
  }
}

function* handleTogglePublish(action) {
  const { postId, isPublished } = action.payload;
  // const user = JSON.parse(localStorage.getItem("user"));
  if (!isPublished) {
    try {
      yield call(togglePostPublish,  postId,);
      yield put(togglePublishSuccess(action.payload));
      yield put(fetchPostsRequest());
      message.success("Post status published successfully!");
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "Failed to publish";
      yield put(togglePublishFailure());
      message.error(errorMsg);
    }
  } else {
    try {
      yield call(togglePostUnpublish, postId);
      yield put(toggleUnpublishSuccess(action.payload));
      yield put(fetchPostsRequest());
      message.success("Post status unpublished successfully!");
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "Failed to unpublish";
      yield put(toggleUnpublishFailure());
      message.error(errorMsg);
    }
  }
}
function* handleToggleByIdPublish(action) {
  const { postId, isPublished } = action.payload;
  if (!isPublished) {
    try {
      const response = yield call(togglePostPublish, postId);
      yield put(togglePublishByIdSuccess(action.payload));
      yield put(fetchPostByIdSuccess(response.data.data));

      message.success("Post status published successfully!");
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "Failed to publish";
      yield put(togglePublishByIdFailure());
      message.error(errorMsg);
    }
  } else {
    try {
      const response = yield call(togglePostUnpublish, postId);
      yield put(toggleUnpublishByIdSuccess(action.payload));
      yield put(fetchPostByIdSuccess(response.data.data));

      message.success("Post status Unpublished successfully!");
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "Failed to publish";
      yield put(toggleUnpublishByIdFailure());
      message.error(errorMsg);
    }
  }
}

function* handlePostById(action) {
  const token = localStorage.getItem("token");
  const { postId } = action.payload;
  console.log("postId in saga:", postId);

  try {
    const response = yield call(getPostById, token, postId);
    yield put(fetchPostByIdSuccess(response.data.data));
  } catch (error) {
    yield put(fetchPostByIdFailure(error));
    const errorMsg = error?.response?.data?.message || "Failed to publish";
    message.error(errorMsg);
  }
}
function* handleFetchPostForContent(action) {
  const token = localStorage.getItem("token");
  const postId = action.payload;
  console.log("postId in saga for content:", postId);
  console.log("action.payload:", action.payload);
  try {
    const response = yield call(getPostById, token, postId);
    yield put(fetchPostByIdSuccessForcontent(response.data));
  } catch (error) {
    yield put(fetchPostByIdFailure());
    yield put();
    const errorMsg = error?.response?.data?.message || "Failed to publish";
    message.error(errorMsg);
  }
}

function* handlePostUpdate(action) {
  const token = localStorage.getItem("token");
  const { postId, data } = action.payload;

  try {
    const responce = yield call(updatePostById, postId, token, data);
    // Update the post in the store
    yield put(UpdatePostSuccess(responce.data.data));
    // Refetch the updated post
    yield put(fetchPostByIdRequest({ postId }));
    // Optionally update profile details
    yield put(getProfileDetails());
    // Optionally close the modal (if you have an action for that)
    // yield put(createPostModalCancel());
    message.success("Post updated successfully!");
  } catch (error) {
    yield put(UpdatePostFailure());
    const errorMsg = error?.response?.data?.message || "Failed to update post";
    message.error(errorMsg);
  }
}

function* handleAddComment(action) {
  const token = localStorage.getItem("token");

  try {
    const response = yield call(
      addComment,
      action.payload.postId,
      { content: action.payload.content },
      token,
    );
    yield put(addCommentSuccess(response));
  } catch (error) {
    yield put(addCommentFialure(error));
    const errorMsg = error?.response?.data?.message || "Failed to add comment";
    message.error(errorMsg);
  }
}

function* handleDeleteComment(action) {
  const token = localStorage.getItem("token");

  try {
    const response = yield call(
      deleteComment,
      action.payload.postId,
      action.payload.commentId,
      token,
    );
    yield put(deleteCommentSuccess(response));
    message.success("commment deleted successfully");
  } catch (error) {
    yield put(deleteCommentFialure());
    const errorMsg = error?.response?.data?.message || "Failed to delete comment";
    message.error(errorMsg);
  }
}
function* handleEditComment(action) {
  const token = localStorage.getItem("token");

  try {
    const response = yield call(
      editComment,
      action.payload.postId,
      action.payload.commentId,
      action.payload.value,
      token,
    );
    yield put(editCommentSuccess(response));
    message.success("comment edited successfully");
  } catch (error) {
    yield put(editCommentFialure());
    const errorMsg = error?.response?.data?.message || "Failed to edit comment";
    message.error(errorMsg);
  }
}

// Root saga
export default function* postsSaga() {
  yield takeLatest(fetchPostsRequest.type, handleFetchPosts);
  yield takeLatest(togglePublishRequest.type, handleTogglePublish);
  yield takeLatest(deletePostRequest.type, handleDeletePost);
  yield takeLatest(createPostRequest.type, handlecreatePost);
  yield takeLatest(fetchPostByIdRequest.type, handlePostById);
  yield takeLatest(UpdatePostRequest.type, handlePostUpdate);
  yield takeLatest(togglePublishByIdRequest.type, handleToggleByIdPublish);
  yield takeLatest(fetchPostByIdRequestForcontent.type, handleFetchPostForContent);
  yield takeLatest(fetchPostsRequestForDashboard.type, handleFetchPostsForDashBoard);
  yield takeLatest(addCommentRequest.type, handleAddComment);
  yield takeLatest(deleteCommentRequest.type, handleDeleteComment);
  yield takeLatest(editCommentRequest.type, handleEditComment);
}
